import type { OnboardingTourStepOption } from 'models';
import { ContentLeftImage } from './content-left-image';

type P = {
  step?: OnboardingTourStepOption;
};

const OnboardingTourImage = ({ step }: P) => {
  switch (step) {
    case 'consents':
      return <ContentLeftImage alt="Consents" src="/assets/onboarding/web-consnets.png" />;
    case 'finish':
      return <ContentLeftImage alt="Welcome" src="/assets/onboarding/web-finish.png" />;
    case 'intro':
      return <ContentLeftImage alt="Welcome" src="/assets/onboarding/web-intro-bh.png" />;
    case 'profile':
      return <ContentLeftImage alt="Profile" src="/assets/onboarding/web-profile.png" />;
    case undefined:
      return null;
  }
};

export default OnboardingTourImage;
